const isStringUppercase = (string) => string === string.toUpperCase();

export default isStringUppercase;
